// Add Site - gets company custom fields
export const loadCompanyFieldsStart = (payload) => {
  return { type: "LOAD_COMPANY_FIELDS_START", payload }
};

export const loadCompanyFieldsSuccess = (response) => {
  return { type: "LOAD_COMPANY_FIELDS_SUCCESS", response }
};

export const loadCompanyFieldsFailed = (error) => {
  return { type: "LOAD_COMPANY_FIELDS_FAILED", error }
};

export const loadCompanyFieldsReset = () => {
  return { type: "LOAD_COMPANY_FIELDS_RESET" }
};

// Add Site - gets enterprise custom fields
export const loadEnterpriseFieldsStart = (payload) => {
  return { type: "LOAD_ENTERPRISE_FIELDS_START", payload }
};

export const loadEnterpriseFieldsSuccess = (response) => {
  return { type: "LOAD_ENTERPRISE_FIELDS_SUCCESS", response }
};

export const loadEnterpriseFieldsFailed = (error) => {
  return { type: "LOAD_ENTERPRISE_FIELDS_FAILED", error }
};

export const loadEnterpriseFieldsReset = () => {
  return { type: "LOAD_ENTERPRISE_FIELDS_RESET" }
};

// Add Site - gets enterprise groups
export const loadEnterpriseGroupsStart = (payload) => {
  return { type: "LOAD_ENTERPRISE_GROUPS_START", payload }
};

export const loadEnterpriseGroupsSuccess = (response) => {
  return { type: "LOAD_ENTERPRISE_GROUPS_SUCCESS", response }
};

export const loadEnterpriseGroupsFailed = (error) => {
  return { type: "LOAD_ENTERPRISE_GROUPS_FAILED", error }
};

export const loadEnterpriseGroupsReset = () => {
  return { type: "LOAD_ENTERPRISE_GROUPS_RESET" }
};

// -- Asset Editor --

// Get sudo site id (using site ref and company id)
// export const loadSudoSiteIdStart = (payload) => {
//   return { type: "LOAD_SUDO_SITE_ID_START", payload }
// };

// export const loadSudoSiteIdSuccess = (response) => {
//   return { type: "LOAD_SUDO_SITE_ID_SUCCESS", response }
// };

// export const loadSudoSiteIdFailed = (error) => {
//   return { type: "LOAD_SUDO_SITE_ID_FAILED", error }
// };

// export const loadSudoSiteIdReset = () => {
//   return { type: "LOAD_SUDO_SITE_ID_RESET" }
// };

// Pin Mapping
export const loadPinMapsStart = (params) => {
  return { type: "LOAD_PIN_MAPS_START", ...params };
};

export const loadPinMapsSuccess = (params) => {
  return { type: "LOAD_PIN_MAPS_SUCCESS", ...params, };
};

export const loadPinMapsFailed = (params) => {
  return { type: "LOAD_PIN_MAPS_FAILED", ...params };
};

export const loadPinMapsCancel = (params) => {
  return { type: "LOAD_PIN_MAPS_CANCEL", ...params };
};

export const loadPinMapsReset = () => {
  return { type: "LOAD_PIN_MAPS_RESET" };
};

// Enterprise Associations
export const loadEnterpriseAssociationsStart = (payload) => {
  return { type: "LOAD_ENTERPRISE_ASSOCIATIONS_START", payload };
};

export const loadEnterpriseAssociationsSuccess = (response) => {
  return { type: "LOAD_ENTERPRISE_ASSOCIATIONS_SUCCESS", response };
};

export const loadEnterpriseAssociationsFailed = (error) => {
  return { type: "LOAD_ENTERPRISE_ASSOCIATIONS_FAILED", error };
};

// Assets - Company
export const loadCompanyAssetsStart = (params) => {
  return { type: "LOAD_COMPANY_ASSETS_START", ...params };
};

export const loadCompanyAssetsSuccess = (response, filterData) => {
  return { type: "LOAD_COMPANY_ASSETS_SUCCESS", payload: { response, filterData } };
};

export const loadCompanyAssetsFailed = (payload) => {
  return { type: "LOAD_COMPANY_ASSETS_FAILED", payload };
};

// Assets - Site
export const loadSiteAssetsStart = (params) => {
  return { type: "LOAD_SITE_ASSETS_START", ...params };
};

export const loadSiteAssetsSuccess = (params) => {
  return { type: "LOAD_SITE_ASSETS_SUCCESS", ...params };
};

export const loadSiteAssetsFailed = (params) => {
  return { type: "LOAD_SITE_ASSETS_FAILED", ...params };
};

export const setAssetId = (payload) => {
  return { type: "SET_ASSET_ID", payload };
};

export const setSiteAssetViewUid = (payload) => {
  return { type: "SET_SITE_ASSET_VIEW_UID", payload };
};

export const loadSiteAssetsReset = (payload) => {
  return { type: "LOAD_SITE_ASSETS_RESET", payload };
};

// Assets - Company Import Logs
export const loadCompanyAssetLogsStart = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOGS_START", ...payload };
};

export const loadCompanyAssetLogsSuccess = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOGS_SUCCESS", ...payload };
};

export const loadCompanyAssetLogsFailed = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOGS_FAILED", ...payload };
};

// Assets - Company Import Logs
export const loadCompanyAssetLogViewStart = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOG_VIEW_START", ...payload };
};

export const loadCompanyAssetLogViewSuccess = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOG_VIEW_SUCCESS", ...payload };
};

export const loadCompanyAssetLogViewFailed = (payload) => {
  return { type: "LOAD_COMPANY_ASSET_LOG_VIEW_FAILED", ...payload };
};

export const resetCompanyAssetLogView = () => {
  return { type: "RESET_COMPANY_ASSET_LOG_VIEW" };
};


// Manage Enterprise Associations ---------------------------|>
// Enteprises Associated With Company ------------------->
export const loadCompanyAssociatedEnterprisesStart = (payload) => {
  return { type: "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_START", ...payload };
};

export const loadCompanyAssociatedEnterprisesSuccess = (payload) => {
  return { type: "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_SUCCESS", ...payload };
};

export const loadCompanyAssociatedEnterprisesFailed = (payload) => {
  return { type: "LOAD_COMPANY_ASSOCIATED_ENTERPRISES_FAILED", ...payload };
};
// ------------------------------------------------|
// Enteprises NOT Associated With Company ------------------->
export const loadCompanyUnassociatedEnterprisesStart = (payload) => {
  return { type: "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_START", ...payload };
};

export const loadCompanyUnassociatedEnterprisesSuccess = (payload) => {
  return { type: "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_SUCCESS", ...payload };
};

export const loadCompanyUnassociatedEnterprisesFailed = (payload) => {
  return { type: "LOAD_COMPANY_UNASSOCIATED_ENTERPRISES_FAILED", ...payload };
};
// Soft Deleted Enteprises Associated With The Company ------------------->
export const loadCompanyDeletedEnterprisesStart = (payload) => {
  return { type: "LOAD_COMPANY_DELETED_ENTERPRISES_START", ...payload };
};

export const loadCompanyDeletedEnterprisesSuccess = (payload) => {
  return { type: "LOAD_COMPANY_DELETED_ENTERPRISES_SUCCESS", ...payload };
};

export const loadCompanyDeletedEnterprisesFailed = (payload) => {
  return { type: "LOAD_COMPANY_DELETED_ENTERPRISES_FAILED", ...payload };
};
// ------------------------------------------------|
// ---------------------------------------------------------||

// Load Company Sites in Create Enteprise Modal 
// (separate actions used to avoid reloading main data table results) ------------------->
export const loadCompanyCreateEnterpriseStart = (payload) => {
  return { type: "LOAD_COMPANY_CREATE_ENTERPRISE_START", ...payload };
};

export const loadCompanyCreateEnterpriseSuccess = (payload) => {
  return { type: "LOAD_COMPANY_CREATE_ENTERPRISE_SUCCESS", ...payload };
};

export const loadCompanyCreateEnterpriseFailed = (payload) => {
  return { type: "LOAD_COMPANY_CREATE_ENTERPRISE_FAILED", ...payload };
};

export const loadCompanyCreateEnterpriseReset = () => {
  return { type: "LOAD_COMPANY_CREATE_ENTERPRISE_RESET" };
};
// --------------------------------------------------------------------------------------|

export const storeSiteRef = (params) => {
  return { type: "STORE_SITE_REF", ...params };
}
